import { render, staticRenderFns } from "./BankAccountDialog.vue?vue&type=template&id=19b39a96&scoped=true&"
import script from "./BankAccountDialog.vue?vue&type=script&lang=js&"
export * from "./BankAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountDialog.vue?vue&type=style&index=0&id=19b39a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b39a96",
  null
  
)

export default component.exports